import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '@/libs/baseApi.client';
import type { CompleteAdMutationRequest, CompleteAdMutationResponse, WatchGoogleAdsQueryRequest } from '../type';
const adsQueryKeys = {
  all: ['watch-google-ads'] as const,
  available: () => [...adsQueryKeys.all, 'available'] as const
};
const useCheckAdAvailableQuery = t0 => {
  const $ = _c(3);
  const enabled = t0 === undefined ? false : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = adsQueryKeys.available();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== enabled) {
    t2 = {
      queryKey: t1,
      queryFn: _temp,
      enabled
    };
    $[1] = enabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return useQuery(t2);
};
const useCompleteAdMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export { adsQueryKeys, useCheckAdAvailableQuery, useCompleteAdMutation };
async function _temp() {
  const response = await api.get("/platform-actions/ad/availability");
  return response.data;
}
async function _temp2(data) {
  const response = await api.post("/platform-actions/ad/complete", data);
  return response.data;
}